<template>
  <v-container>
    <!-- Alerta -->
    <div class="alerta">
      <v-row>
        <v-col cols="12" md="2" xl="1" class="alerta-icone">
          <v-img src="@/assets/images/icone/espaco-colaborador/icone_sinal_de_aviso.svg"></v-img>
        </v-col>
        <v-col cols="12" md="10" xl="11" class="alerta-texto">
          <span>
            Para saber os valores da mensalidade, percentuais de participação da Hepta e outras
            informações sobre coparticipação,reembolso e carência, acesse
            <a
              href="https://nossahepta.com.br/IntranetHepta/#/detalhe-academia?id=1207&pesquisa=false&artigo=true"
              target="_blank"
              >Nossa Hepta > Espaço do Colaborador > Benefícios > Plano de Saúde</a
            >
          </span>
        </v-col>
      </v-row>
    </div>

    <!-- Titular -->
    <v-row>
      <v-col class="titulo-e-divider">
        <h2 class="titulo-secao">Titular</h2>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6" lg="4" xl="3" offset-lg="4" offset-xl="6">
        <v-btn
          v-if="beneficio.length === 0"
          @click="abrirModalPlanoDeSaude(false)"
          class="botao-principal w-100"
        >
          <v-icon class="mr-2">fas fa-plus</v-icon> Solicitar Plano de Saúde
        </v-btn>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="3">
        <v-btn @click="showMinhasSolicitacoes = true" class="botao-principal w-100">
          <v-img
            class="icone-solicitacoes"
            src="@/assets/images/icone/espaco-colaborador/icone_document.svg"
          ></v-img>
          Minhas Solicitações
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headerTitular"
          :items="beneficio"
          :hide-default-footer="true"
          no-data-text="Você não possui plano de saúde cadastrado!"
        >
          <template
            v-for="header in headerTitular.filter(header => header.hasOwnProperty('formatter'))"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.requerimento`]="{ item }">
            <v-row>
              <v-col cols="12" md="6">
                <v-btn @click="abrirModalPlanoDeSaude(true, item)" class="botao-amarelo">
                  Trocar Plano de Saúde
                </v-btn>
              </v-col>
              <v-col cols="12" md="6">
                <v-btn @click="cancelarPlano(item)" class="botao-vermelho"
                  >Cancelar Benefícios</v-btn
                >
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <!-- Dependentes -->
    <v-row>
      <v-col class="titulo-e-divider">
        <h2 class="titulo-secao">Dependentes</h2>
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row class="justify-end espacamento-btn-adicionar my-5">
      <v-col cols="12" md="6" lg="4" xl="3" offset-md="6" offset-lg="8" offset-xl="9">
        <v-btn
          v-show="beneficio.length > 0"
          @click="adicionarDependete()"
          class="botao-principal w-100"
        >
          <v-icon class="mr-2">fas fa-circle-plus</v-icon> Adicionar Dependentes
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headerDependente"
          :items="dependente"
          no-data-text="Você não possui dependentes com Planos de Saúde cadastrados!"
          :hide-default-footer="true"
        >
          <template
            v-for="header in headerDependente.filter(header => header.hasOwnProperty('formatter'))"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.requerimento`]="{ item }">
            <v-btn @click="removerDependente(item)" class="botao-vermelho"
              >Remover Dependente</v-btn
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <alerta
      v-on:fecharModal="fecharModal"
      :exibir="modal.exibir"
      :titulo="modal.titulo"
      :mensagem="modal.mensagem"
    />

    <ModalMinhasSolicitacoes v-model="showMinhasSolicitacoes" />

    <ModalCancelarBeneficio
      v-model="modalCancelarBeneficio.showCancelarPlano"
      :beneficio="modalCancelarBeneficio.beneficio"
      :tipoMudanca="modalCancelarBeneficio.tipoMudanca"
      :tituloModal="modalCancelarBeneficio.tituloModal"
      :dependentes="modalCancelarBeneficio.dependente"
      @sucesso="
        mensagemSucesso('Pedido realizado com sucesso. Aguarde o atendimento da solicitação.')
      "
    />

    <ModalAdicionarDependentes
      v-model="modalAdicionarDependente.show"
      :tituloModal="modalAdicionarDependente.titulo"
      :dependentes="modalAdicionarDependente.dependente"
      :beneficio="modalAdicionarDependente.beneficio"
      :tipo="1"
      @sucesso="abrirModalAnexarDocumento"
    />

    <ModalSolicitarPlano v-model="modalSolicitarPlanoSaude.show"
    :titulo="modalSolicitarPlanoSaude.titulo" :dependentes="modalSolicitarPlanoSaude.dependente"
    :tipo="1" :alteracaoPlano="modalSolicitarPlanoSaude.alteracaoPlano"
    :beneficioAnterior="modalSolicitarPlanoSaude.beneficioAnterior""
    @create="abrirModalAnexarDocumento" />

    <ModalAnexarDocumentos
      v-model="modalAnexar.show"
      :pedido="modalAnexar.pedido"
      :alteracao="modalAnexar.alteracao"
    />
  </v-container>
</template>

<script>
import alerta from '@/components/Alerta.vue';
import modalMixin from '@/mixins/modalMixin';
import ModalMinhasSolicitacoes from '@/components/EspacoDoColaborador/Beneficios/modais/ModalMinhasSolicitacoes.vue';
import ModalCancelarBeneficio from '@/components/EspacoDoColaborador/Beneficios/modais/ModalCancelarBeneficio.vue';
import ModalAdicionarDependentes from '@/components/EspacoDoColaborador/Beneficios/modais/ModalAdicionarDependentes.vue';
import { TipoMudancaEnum } from '@/enums/beneficio/TipoMudancaEnum.js';
import ModalSolicitarPlano from '@/components/EspacoDoColaborador/Beneficios/modais/ModalSolicitarPlano.vue';
import ModalAnexarDocumentos from '@/components/EspacoDoColaborador/Beneficios/modais/ModalAnexarDocumentos.vue';

export default {
  components: {
    ModalMinhasSolicitacoes,
    ModalCancelarBeneficio,
    ModalAdicionarDependentes,
    alerta,
    ModalSolicitarPlano,
    ModalAnexarDocumentos,
  },
  props: {
    beneficio: Array,
    dependente: Array,
    headerTitular: Array,
    headerDependente: Array,
  },
  mixins: [modalMixin],
  data() {
    return {
      showMinhasSolicitacoes: false,
      modalCancelarBeneficio: {
        showCancelarPlano: false,
        beneficio: null,
        tipoMudanca: null,
        tituloModal: null,
        dependente: [],
      },
      modalAdicionarDependente: {
        show: false,
        dependentes: [],
        beneficio: null,
        titulo: '',
      },
      modalSolicitarPlanoSaude: {
        show: false,
        dependentes: [],
        titulo: '',
        alteracaoPlano: false,
      },
      modalAnexar: {
        show: false,
        pedido: null,
      },
    };
  },
  methods: {
    cancelarPlano(item) {
      const vm = this;
      vm.modalCancelarBeneficio = {
        beneficio: item,
        tipoMudanca: TipoMudancaEnum.CANCELAMENTO,
        tituloModal: 'Cancelar plano de saúde',
        dependente: vm.dependente.filter(d => {
          return d.beneficios == item.descricao;
        }),
        showCancelarPlano: true,
      };
    },
    removerDependente(item) {
      const vm = this;
      vm.modalCancelarBeneficio = {
        beneficio: vm.beneficio.find(b => {
          return b.descricao == item.beneficios;
        }),
        tipoMudanca: TipoMudancaEnum.REMOVER_DEPENDENTE,
        tituloModal: `Remover ${item.nome} do plano de saúde`,
        dependente: [item],
        showCancelarPlano: true,
      };
    },
    adicionarDependete() {
      const vm = this;
      vm.modalAdicionarDependente = {
        titulo: 'Adicionar dependente ao plano de saúde',
        dependente: vm.dependente,
        beneficio: vm.beneficio[0],
        show: true,
      };
    },
    abrirModalPlanoDeSaude(alteracao, beneficioAnterior = {}) {
      const vm = this;
      vm.modalSolicitarPlanoSaude = {
        titulo: !alteracao ? `Solicitar Plano de saúde` : 'Trocar Plano de saúde',
        show: true,
        alteracaoPlano: alteracao,
        beneficioAnterior: beneficioAnterior,
      };
    },
    abrirModalAnexarDocumento(item) {
      const vm = this;
      vm.modalAnexar = {
        pedido: item,
        show: true,
        alteracao: item.tipoMudanca.id === 1,
      };
    },
  },
};
</script>
